module.exports = "/assets/mastertherm.png";